import { useState } from "react";
import { useToast } from "@components/ui/use-toast";

function ExpandableDescription({ text }: { text: string }) {
  const [expanded, setExpanded] = useState(false);

  const isLong = text.length > 180;

  return (
    <div className="text-sm text-muted-background">
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out max-w-[355px] break-words ${
          expanded ? "max-h-[500px] overflow-y-auto" : "max-h-[72px]"
        }`}
      >
        {text}
      </div>

      {isLong && (
        <button
          onClick={() => setExpanded((prev) => !prev)}
          className="mt-1 text-xs font-bold text-muted-background hover:underline"
        >
          {expanded ? "See less..." : "See more..."}
        </button>
      )}
    </div>
  );
}

type ToastOptions = {
  title?: string;
  description?: string;
  variant?: any;
  duration?: number;
};

export const useCustomToast = () => {
  const { toast } = useToast();

  const showToast = ({ title, description, ...rest }: ToastOptions) => {
    toast({
      title,
      description: description ? (
        <ExpandableDescription text={description} />
      ) : undefined,
      ...rest,
    });
  };

  return { showToast };
};
